import React, { useContext } from 'react';
import { GetServerSidePropsContext } from 'next';
import useTranslation from 'next-translate/useTranslation';

import Footer from '@invideoio/web-shared/components/Footer';

import { footerExploreLinks } from '@constants/footerExplore';
import { getPage } from '@lib/API';
import AppLayout from '@layouts/AppLayout';
import { StateContext } from '@store/store';
import HomepageSEO from '@components/common/SEO/HomepageSEO';
import PageHeading from '@components/PageHeading';
import { PageResponseType } from 'src/types';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import HeaderWithCTAI from '@components/header-ai';

interface PageProps {
  pageState: PageResponseType;
}

function Pages({ pageState }: PageProps) {
  const globalState = useContext(StateContext);
  const { platform, os, config } = globalState;
  const { lang } = useTranslation();

  return (
    <AppLayout platform={platform}>
      <HomepageSEO seo={pageState.SEO} />
      <HeaderWithCTAI />

      <div className={ivclass('xl:iv-container xl:iv-mx-auto iv-my-50')}>
        <PageHeading
          className={ivclass(
            'iv-text-heading-5xl lg:iv-text-heading-4xl md:iv-text-heading-4xl sm:iv-text-heading-s',
            'iv-m-heading-5xl lg:iv-m-heading-4xl md:iv-m-heading-4xl sm:iv-m-heading-s',
            'iv-text-center',
            'iv-text-grey-100',
            'iv-font-extrabold',
          )}
        >
          <span className="iv-title-gradient">{pageState.Head?.Title}</span>
        </PageHeading>
      </div>
      <main className={ivclass('xl:iv-container xl:iv-mx-auto iv-mb-10')}>
        <div
          className="iv-max-w-[1170px] iv-min-w-[240px] iv-my-50 iv-p-20 iv-mx-auto"
          dangerouslySetInnerHTML={{ __html: pageState.ContentBody }}
        ></div>
      </main>
      <Footer
        os={os}
        platform={platform}
        socialLinks={globalState.socialLinks}
        exploreLinks={footerExploreLinks[config?.env?.siteId][lang].links}
      />
    </AppLayout>
  );
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  let pageState = null;
  try {
    const pageStrpiUrl = process.env.NEXT_PUBLIC_PAGES_CMS_ENDPOINT;
    const Slug = (ctx.query.slug as string) || '';
    pageState = await getPage(pageStrpiUrl, Slug, ctx.locale);
  } catch (error) {
    console.log(error);
    return { notFound: true };
  }
  return { props: { pageState } };
}

export default Pages;
